// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Toggle_Switch__1J28s","Slider":"Toggle_Slider__1g9nU"};